/* tslint:disable */
/* eslint-disable */
/**
 * CGN Onboarding Portal Public API
 * Carta Giovani Nazionale Onboarding Portal - Public API
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface ActiveDirectoryData
 */
export interface ActiveDirectoryData {
    /**
     * Authentication token received from Active Directory
     * @type {string}
     * @memberof ActiveDirectoryData
     */
    'token': string;
    /**
     * random field
     * @type {string}
     * @memberof ActiveDirectoryData
     */
    'nonce': string;
    /**
     * discriminator field
     * @type {string}
     * @memberof ActiveDirectoryData
     */
    'requestType': string;
}
/**
 * @type CreateJwtSessionTokenRequest
 * @export
 */
export type CreateJwtSessionTokenRequest = { requestType: 'ad' } & ActiveDirectoryData | { requestType: 'oi' } & OneIdentityData;

/**
 * 
 * @export
 * @interface HelpRequest
 */
export interface HelpRequest {
    /**
     * 
     * @type {string}
     * @memberof HelpRequest
     */
    'legalName': string;
    /**
     * 
     * @type {string}
     * @memberof HelpRequest
     */
    'referentFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof HelpRequest
     */
    'referentLastName': string;
    /**
     * 
     * @type {string}
     * @memberof HelpRequest
     */
    'emailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof HelpRequest
     */
    'category': HelpRequestCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof HelpRequest
     */
    'topic'?: string;
    /**
     * 
     * @type {string}
     * @memberof HelpRequest
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof HelpRequest
     */
    'recaptchaToken': string;
}

export const HelpRequestCategoryEnum = {
    Access: 'Access',
    DataFilling: 'DataFilling',
    Discounts: 'Discounts',
    Documents: 'Documents',
    TechnicalProblem: 'TechnicalProblem',
    CgnOwnerReporting: 'CgnOwnerReporting',
    Suggestions: 'Suggestions',
    Other: 'Other'
} as const;

export type HelpRequestCategoryEnum = typeof HelpRequestCategoryEnum[keyof typeof HelpRequestCategoryEnum];

/**
 * 
 * @export
 * @interface OneIdentityData
 */
export interface OneIdentityData {
    /**
     * code received from One Identity
     * @type {string}
     * @memberof OneIdentityData
     */
    'code': string;
    /**
     * random field
     * @type {string}
     * @memberof OneIdentityData
     */
    'nonce': string;
    /**
     * discriminator field
     * @type {string}
     * @memberof OneIdentityData
     */
    'requestType': string;
}

/**
 * HelpApi - axios parameter creator
 * @export
 */
export const HelpApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Send an help request
         * @param {HelpRequest} helpRequest Help request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendHelpRequest: async (helpRequest: HelpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'helpRequest' is not null or undefined
            assertParamExists('sendHelpRequest', 'helpRequest', helpRequest)
            const localVarPath = `/help`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(helpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HelpApi - functional programming interface
 * @export
 */
export const HelpApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HelpApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Send an help request
         * @param {HelpRequest} helpRequest Help request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendHelpRequest(helpRequest: HelpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendHelpRequest(helpRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpApi.sendHelpRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HelpApi - factory interface
 * @export
 */
export const HelpApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HelpApiFp(configuration)
    return {
        /**
         * 
         * @summary Send an help request
         * @param {HelpApiSendHelpRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendHelpRequest(requestParameters: HelpApiSendHelpRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendHelpRequest(requestParameters.helpRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for sendHelpRequest operation in HelpApi.
 * @export
 * @interface HelpApiSendHelpRequestRequest
 */
export interface HelpApiSendHelpRequestRequest {
    /**
     * Help request
     * @type {HelpRequest}
     * @memberof HelpApiSendHelpRequest
     */
    readonly helpRequest: HelpRequest
}

/**
 * HelpApi - object-oriented interface
 * @export
 * @class HelpApi
 * @extends {BaseAPI}
 */
export class HelpApi extends BaseAPI {
    /**
     * 
     * @summary Send an help request
     * @param {HelpApiSendHelpRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HelpApi
     */
    public sendHelpRequest(requestParameters: HelpApiSendHelpRequestRequest, options?: RawAxiosRequestConfig) {
        return HelpApiFp(this.configuration).sendHelpRequest(requestParameters.helpRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SessionApi - axios parameter creator
 * @export
 */
export const SessionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint accepts two alternative forms of data: - OneIdentityData to login from One Identity (code + state) - ActiveDirectoryData to login from Active Directory (pagopa_token) 
         * @summary creates a user session
         * @param {CreateJwtSessionTokenRequest} createJwtSessionTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJwtSessionToken: async (createJwtSessionTokenRequest: CreateJwtSessionTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createJwtSessionTokenRequest' is not null or undefined
            assertParamExists('createJwtSessionToken', 'createJwtSessionTokenRequest', createJwtSessionTokenRequest)
            const localVarPath = `/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createJwtSessionTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SessionApi - functional programming interface
 * @export
 */
export const SessionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SessionApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint accepts two alternative forms of data: - OneIdentityData to login from One Identity (code + state) - ActiveDirectoryData to login from Active Directory (pagopa_token) 
         * @summary creates a user session
         * @param {CreateJwtSessionTokenRequest} createJwtSessionTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createJwtSessionToken(createJwtSessionTokenRequest: CreateJwtSessionTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createJwtSessionToken(createJwtSessionTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SessionApi.createJwtSessionToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SessionApi - factory interface
 * @export
 */
export const SessionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SessionApiFp(configuration)
    return {
        /**
         * This endpoint accepts two alternative forms of data: - OneIdentityData to login from One Identity (code + state) - ActiveDirectoryData to login from Active Directory (pagopa_token) 
         * @summary creates a user session
         * @param {SessionApiCreateJwtSessionTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJwtSessionToken(requestParameters: SessionApiCreateJwtSessionTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.createJwtSessionToken(requestParameters.createJwtSessionTokenRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createJwtSessionToken operation in SessionApi.
 * @export
 * @interface SessionApiCreateJwtSessionTokenRequest
 */
export interface SessionApiCreateJwtSessionTokenRequest {
    /**
     * 
     * @type {CreateJwtSessionTokenRequest}
     * @memberof SessionApiCreateJwtSessionToken
     */
    readonly createJwtSessionTokenRequest: CreateJwtSessionTokenRequest
}

/**
 * SessionApi - object-oriented interface
 * @export
 * @class SessionApi
 * @extends {BaseAPI}
 */
export class SessionApi extends BaseAPI {
    /**
     * This endpoint accepts two alternative forms of data: - OneIdentityData to login from One Identity (code + state) - ActiveDirectoryData to login from Active Directory (pagopa_token) 
     * @summary creates a user session
     * @param {SessionApiCreateJwtSessionTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionApi
     */
    public createJwtSessionToken(requestParameters: SessionApiCreateJwtSessionTokenRequest, options?: RawAxiosRequestConfig) {
        return SessionApiFp(this.configuration).createJwtSessionToken(requestParameters.createJwtSessionTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



